module.exports = __webpack_public_path__ + "static/media/login-cyc.019e7efe.png";